module.exports = __webpack_public_path__ + "img/ea7949e.png";